import { EVENT, emit } from '../utils/events.js';
import { setStoredTheme } from '../utils/storage.js';

export function isDark(theme) {
  if (theme === 'dark') return true;
  if (theme === 'light') return false;
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

export function applyTheme(theme) {
  if (theme === 'system') document.documentElement.removeAttribute('data-theme');
  else document.documentElement.setAttribute('data-theme', theme);
  setStoredTheme(theme === 'system' ? null : theme);
  emit(EVENT.THEME_CHANGED, theme);
}

export function toggleTheme() {
  const current = document.documentElement.getAttribute('data-theme');
  const next = (current === 'dark' || (!current && window.matchMedia('(prefers-color-scheme: dark)').matches))
    ? 'light' : 'dark';
  applyTheme(next);
  return next;
}